import React from 'react';
import { ErrorsWrapper, Text } from 'ui-builder';
import { BriefcaseCheckboxLayoutProps } from '../types';
import styles from './BriefcaseCheckbox.module.scss';

export default function BriefcaseCheckboxLayoutWeb(props: BriefcaseCheckboxLayoutProps) {
  const getValue = () => props.value || false;

  const invertValue = () => {
    props.onChangeCallback({
      target: {
        value: !getValue(),
      },
    });
  };

  return (
    <ErrorsWrapper name={props.name} errors={props.errors}>
      <span title={props.title}>
        {/* eslint-disable jsx-a11y/click-events-have-key-events,
          jsx-a11y/no-static-element-interactions */}
        <i
          className={`${styles.checkbox} ${props.value ? styles.checked : ''} ${props.isDisabled ? styles.disabled : ''}`}
          onClick={() => invertValue()}
        >
          &nbsp;
        </i>
        <Text>{props.label}</Text>
      </span>
    </ErrorsWrapper>
  );
}
